// Константа базового URL
const API_BASE_URL = "https://api.nexus-shop.ru/api";

// Универсальный обработчик ошибок
const handleError = async (response) => {
	let errorMessage = "Unknown error";
	if (response) {
		try {
			const errorData = await response.json();
			errorMessage = errorData.message || response.statusText;
		} catch (e) {
			errorMessage = response.statusText;
		}
	}
	console.error(`HTTP error: ${response.status} ${errorMessage}`);
	throw new Error(errorMessage);
};

// Функция обновления токена.
// Single-flight: если несколько запросов одновременно поймали 401, refresh выполняется
// только один раз, остальные ждут его результат. Иначе параллельные refresh ротируют
// токен наперегонки и часть запросов получает уже недействительный refresh-токен.
let refreshInFlight = null;

const refreshAccessToken = () => {
	if (refreshInFlight) {
		return refreshInFlight;
	}

	refreshInFlight = (async () => {
		const token = localStorage.getItem("nexusToken");
		const refreshToken = localStorage.getItem("refreshNexusToken");
		if (!refreshToken) {
			throw new Error("No refresh token available");
		}

		try {
			const response = await fetch(`${API_BASE_URL}/appuser/refresh`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ token, refreshToken }),
			});

			if (!response.ok) {
				throw new Error("Failed to refresh token");
			}

			const data = await response.json();
			localStorage.setItem("nexusToken", data.token); // Сохраняем новый access token
			localStorage.setItem("refreshNexusToken", data.refreshToken); // Сохраняем новый refresh token

			return data.token;
		} catch (error) {
			console.error("Error refreshing token:", error);
			throw error;
		} finally {
			refreshInFlight = null;
		}
	})();

	return refreshInFlight;
};

// Универсальная функция для запросов API
const fetchApi = async (url, options = {}) => {
	let token = localStorage.getItem("nexusToken");
	let headers = {
		"Content-Type": "application/json",
		...options.headers,
	};

	if (token) {
		headers["Authorization"] = `Bearer ${token}`;
	}

	try {
		let response = await fetch(`${API_BASE_URL}${url}`, {
			headers,
			...options,
		});

		if (response.status === 401) {
			// Если запрос не авторизован, обновляем токен
			token = await refreshAccessToken();

			headers["Authorization"] = `Bearer ${token}`;
			response = await fetch(`${API_BASE_URL}${url}`, {
				headers,
				...options,
			});
		}

		if (!response.ok) {
			await handleError(response);
		}
		const text = await response.text();
		return text ? JSON.parse(text) : {};
	} catch (error) {
		console.error("Fetch error:", error);
		throw error;
	}
};

// // API-функция для входа пользователя
// export const loginUser = async (userId, userName, fullName) => {
// 	try {
// 		const response = await fetchApi("/appuser/login", {
// 			method: "POST",
// 			body: JSON.stringify({ userId, userName, fullName }),
// 		});

// 		if (response.token) {
// 			localStorage.setItem("nexusToken", response.token); // Сохраняем access token
// 			localStorage.setItem("refreshNexusToken", response.refreshToken); // Сохраняем refresh token
// 		}

// 		return response;
// 	} catch (error) {
// 		console.error("Login error:", error);
// 		throw error;
// 	}
// };

export async function loginWithTelegram(initData) {
	try {
		const resp = await fetchApi(
			"/appuser/login/telegram",
			{ method: "POST", body: JSON.stringify({ initData }) },
			{ scheme: null }, // anonymous
		);
		if (resp.token) {
			localStorage.setItem("nexusToken", resp.token); // Сохраняем access token
			localStorage.setItem("refreshNexusToken", resp.refreshToken); // Сохраняем refresh token
		}
		return resp;
	} catch (error) {
		console.error("Login error:", error);
		throw error;
	}
}

export const getUser = async (userId) => {
	try {
		let url = `/user/get?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGame = async (id, userId) => {
	try {
		let url = `/game/get?id=${id}&userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGameLink = async (userId) => {
	try {
		let url = `/game/getAllGamesSuperCell?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGameData = async () => {
	try {
		let url = `/game`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGameDataLimited = async (userId) => {
	try {
		let url = `/game/getAllLimited?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};

export const getGameDataNoLogin = async (userId) => {
	try {
		let url = `/game/getAllNoLogin?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGameDataDiscount = async (userId) => {
	try {
		let url = `/game/getAllDiscount?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getAllCategorizedGames = async (userId) => {
	try {
		let url = `/game/getAllCategorizedGames?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGameDataNew = async (userId) => {
	try {
		let url = `/game/getAllNew?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGameDataPopular = async (userId) => {
	try {
		let url = `/game/getAllPopular?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGameDataOnly = async () => {
	try {
		let url = `/game/getAllGamesOnly`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getGameDataPromotion = async (userId) => {
	try {
		let url = `/game/getAllPromotion?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};

export const getUserBalance = async (userId) => {
	try {
		let url = `/UserBalance/getByUserId?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const getFavoritesByUserId = async (userId) => {
	try {
		let url = `/UserFavorite/getByUserId?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get user error:", error);
		throw error;
	}
};
export const updateUser = async (
	userId,
	userName,
	fullName,
	photoBase64 = null,
	fileName,
) => {
	try {
		// Define the payload
		const payload = {
			userId,
			userName,
			fullName,
			photoBase64,
			fileName, // Include PhotoBase64 if provided
		};

		// Call the API
		const response = await fetchApi("/user/update", {
			method: "POST",
			body: JSON.stringify(payload),
		});

		return response;
	} catch (error) {
		console.error("Update user error:", error);
		throw error;
	}
};

export const updateUserEmail = async (userId, email) => {
	try {
		// Define the payload
		const payload = {
			userId,
			email, // Include PhotoBase64 if provided
		};

		// Call the API
		const response = await fetchApi("/user/updateEmail", {
			method: "POST",
			body: JSON.stringify(payload),
		});

		return response;
	} catch (error) {
		console.error("Update user error:", error);
		throw error;
	}
};

export const setGameLink = async (userId, gameId, gameLink) => {
	try {
		// Define the payload
		const payload = {
			userId,
			gameId,
			gameLink,
		};
		const response = await fetchApi("/UserGameLink/add", {
			method: "POST",
			body: JSON.stringify(payload),
		});
		return response;
	} catch (error) {
		console.error("Update user error:", error);
		throw error;
	}
};
export const sendSupercell = async (game, email) => {
	try {
		// Define the payload
		const payload = {
			game,
			email,
		};
		const response = await fetchApi("/Supercell/login", {
			method: "POST",
			body: JSON.stringify(payload),
		});
		return response;
	} catch (error) {
		console.error("Update user error:", error);
		throw error;
	}
};
export const addUserPurchase = async (
	userId,
	itemId,
	count,
	price,
	friendLink,
	superCell,
	code,
) => {
	try {
		const payload = {
			id: 0,
			userId,
			itemId,
			count,
			price,
			friendLink,
			superCell,
			code,
		};
		const response = await fetchApi("/UserPurchase/add", {
			method: "POST",
			body: JSON.stringify(payload),
		});
		return response;
	} catch (error) {
		console.error("Update user error:", error);
		throw error;
	}
};
export const getUserOrderApp = async (userId) => {
	try {
		let url = `/UserOrder/getOrdersByUserId?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get all users error:", error);
		throw error;
	}
};

export const getFirstOrderByUserIdRateView = async (userId) => {
	try {
		let url = `/UserOrder/getFirstOrderByUserIdRateView?userId=${userId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get all users error:", error);
		throw error;
	}
};

export const getUserPurchase = async (orderId) => {
	try {
		let url = `/UserPurchase/getPurchasesByOrderId?orderId=${orderId}`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get all users error:", error);
		throw error;
	}
};
export const updateFavorite = async (userId, itemId) => {
	try {
		const payload = {
			userId,
			itemId,
		};
		const response = await fetchApi("/UserFavorite/update", {
			method: "POST",
			body: JSON.stringify(payload),
		});
		return response;
	} catch (error) {
		console.error("Update user error:", error);
		throw error;
	}
};

export const createInvoiceTBank = async (data) => {
	try {
		const response = await fetchApi("/TBank/process", {
			method: "POST",
			body: JSON.stringify(data),
		});
		return response;
	} catch (error) {
		console.error("Payment create failure:", error);
		throw error;
	}
};
export const AddOrder = async (data) => {
	try {
		const response = await fetchApi("/UserOrder/WithPurchases", {
			method: "POST",
			body: JSON.stringify(data),
		});
		return response;
	} catch (error) {
		console.error("Payment create failure:", error);
		throw error;
	}
};

export const AddUserRate = async (data) => {
	try {
		const response = await fetchApi("/UserRate/add", {
			method: "POST",
			body: JSON.stringify(data),
		});
		return response;
	} catch (error) {
		console.error("Payment create failure:", error);
		throw error;
	}
};

export const AddOrderBalance = async (data) => {
	try {
		const response = await fetchApi("/UserOrder/add", {
			method: "POST",
			body: JSON.stringify(data),
		});
		return response;
	} catch (error) {
		console.error("Payment create failure:", error);
		throw error;
	}
};
export const checkTBank = async (data) => {
	try {
		const response = await fetchApi("/TBank/check", {
			method: "POST",
			body: JSON.stringify(data),
		});
		return response;
	} catch (error) {
		console.error("Get users by IDs error:", error);
		throw error;
	}
};

export const getBanners = async () => {
	try {
		let url = `/Banner`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get all users error:", error);
		throw error;
	}
};

export const getRatesByGameIdPaged = async (gameId, page = 1, pageSize = 5) => {
	try {
		let url = `/UserRate/getByGameIdPaged?gameId=${gameId}&page=${page}&pageSize=${pageSize}`;

		const response = await fetchApi(url, {
			method: "GET",
		});

		return response;
	} catch (error) {
		console.error("Get paged rates error:", error);
		throw error;
	}
};

export const getAllRates = async () => {
	try {
		let url = `/UserRate/getAll`;
		const response = await fetchApi(url, {
			method: "GET",
		});
		return response;
	} catch (error) {
		console.error("Get all users error:", error);
		throw error;
	}
};
